import HelpBox from 'containers/SignupPages/AuthByContractEpargnFailed/helpBox';
import messages from 'containers/SignupPages/AuthByContractEpargnFailed/messages';
import {
  VERIFY_IDENTITY,
  PERSONAL_INFO,
} from 'containers/SignupPages/constants';
import IsContractFoundResponse from 'containers/SignupPages/IsContractFoundResponse';
import { translate } from 'helpers/intl';
import { pushTo } from 'helpers/routes';
import React from 'react';
import { injectIntl, IntlShape } from 'react-intl';
import pages from 'routes/pages';

export type AuthByContractEpargnFailedProps = {
  intl: IntlShape;
  setSignupStep: Function;
};
const AuthByContractEpargnFailed = (props: AuthByContractEpargnFailedProps) => {
  return (
    <React.Fragment>
      <IsContractFoundResponse
        nextLabel={translate({ ...messages.nextLabel }, props)}
        previousLabel={translate({ ...messages.previousLabel }, props)}
        isFound={false}
        title={translate({ ...messages.title }, props)}
        subTitle={translate({ ...messages.subTitle }, props)}
        onClickNext={() => {
          props.setSignupStep(VERIFY_IDENTITY);
        }}
        onClickPrevious={() => {
          props.setSignupStep(PERSONAL_INFO);
          pushTo(pages.SIGNUP);
        }}
        gridXs={6}
        gridNextButton={6}
      >
        <HelpBox />
      </IsContractFoundResponse>
    </React.Fragment>
  );
};

export default injectIntl(AuthByContractEpargnFailed);
